const CHAT_MODES = {
    FREE: "free",
    GUIDED: "guided",
    TYPE: {
      PHARMA: "pharma",
      AUTOMOBILE: "automobile",
      SSPL_BLOG_Posts: "sspl_blog_posts",
      NAISS: "naiss_user_manual",
      HI_BRO: "hi_bro",
      HI_CRM: "hi_crm",
      UNIFIED: "unified",
    }
  };

  export default CHAT_MODES